/**
 * URL helpers for the AB AI guide experiments (#13747, #18613).
 *
 * The variant pages of these experiments use the base slug plus an
 * experiment marker and a variant letter, for example
 * `x-vb13747-j-summary-author` or `x-pbp18613-b-summary-author`.
 * Keep the markers in sync with `ai_book_exp_suffix()` in
 * `backend/app/book/ab_ai_guide.py`.
 */

const AB_AI_GUIDE_URL_MARKERS = ['-vb13747', '-pbp18613']

// A marker with the variant letter that follows it, such as `-pbp18613-b`.
const AB_AI_GUIDE_VARIANT_REGEXP = new RegExp(
  `(?:${AB_AI_GUIDE_URL_MARKERS.join('|')})(?:-[a-z](?=[-/]|$))?`,
)

/**
 * Check if the URL or slug belongs to an AB AI guide experiment variant.
 */
export function isAbAiGuideVariantUrl(url: string): boolean {
  return AB_AI_GUIDE_URL_MARKERS.some((marker) => url.includes(marker))
}

/**
 * Remove the experiment variant part (such as `-pbp18613-b`) from a URL,
 * so it points to the base (control) page.
 */
export function stripAbAiGuideVariant(url: string): string {
  return url.replace(AB_AI_GUIDE_VARIANT_REGEXP, '')
}
